import { effects } from 'redux-saga'

import { forgetAllSignups } from '../../modules/signupEdit/actions'

export default function* forgetAll() {
  yield effects.put.resolve(forgetAllSignups())
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/forgetAll.js